<template>
  <div class="fill-height">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#ff64ad">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="650"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id !== '' ? 'Ubah' : 'Tambah' }} Group Petugas Registrasi
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; reset();"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <div
                class="body-1 font-weight-light mb-3">
                Silahlan pilih role, kemudian pilih user / pengguna yang akan dimasukkan ke dalam group petugas registrasi tersebut:
              </div>

              <ValidationProvider 
                name="role_id" 
                rules="required"
                v-slot="{ errors, valid }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Role
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </p>

                <v-select
                  v-on:keyup.enter="save"
                  style="max-width: 70%;"
                  outlined
                  dense
                  color="#ff64ad"
                  placeholder="Contoh. Klaten"
                  
                  :items="list.role"
                  item-text="user_role_name"
                  item-value="user_role_id"
                  item-color="#ff64ad"

                  hide-details

                  @change="
                    form.role_kecamatan_code = '';
                    form.role_kecamatan_name = '';
                    form.role_kelurahan_code = '';
                    form.role_kelurahan_name = '';"

                  v-model="form.role_id"
                  :success="form.role_id !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Role {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.role_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <div v-if="Object.keys(selected.detail).length > 0"
                class="my-4">
                <div
                  class="black--text mb-2">
                  Berikut adalah layanan dari role <b>{{ selected.detail.user_role_name }}</b>:
                </div>

                <div
                  class="black--text font-weight-light text-capitalize"
                  style="opacity: 60%;">
                  <ul
                    style="padding-left: 15px;">
                    <li
                      v-for="(item, index) in selected.detail.user_role_access.split(',')"
                      :key="index">
                      {{ item.replace(/_/g, ' ') }}
                    </li>
                  </ul> 
                </div>

                <div v-if="form.role_id !== ''"
                  class="mt-6 mb-3">
                  <ValidationProvider 
                    name="role_kabupaten_code" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kabupaten
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save"
                      style="max-width: 55%;"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. Klaten"
                      
                      :items="config.city"
                      item-value="kabupaten_code"
                      item-text="kabupaten_name"
                      item-color="#ff64ad"

                      @change="
                        form.role_kecamatan_code = '';
                        form.role_kecamatan_name = '';
                        form.role_kelurahan_code = '';
                        form.role_kelurahan_name = '';"

                      v-model="form.role_kabupaten_code"
                      :success="form.role_kabupaten_code !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Kabupaten / Kota {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_kabupaten_code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </div>

                <div v-if="selected.detail.user_role_level === 'Kecamatan' || selected.detail.user_role_level === 'Desa / Kelurahan'"
                  class="mt-6 mb-3">
                  <ValidationProvider 
                    name="role_kecamatan_code" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kecamatan
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save"
                      style="max-width: 55%;"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. Trucuk"

                      :search-input.sync="autocomplete.subdistrict"
                      :loading="process.subdistrict"
                      
                      :items="config.subdistrict"
                      item-value="kecamatan_code"
                      item-text="kecamatan_name"
                      item-color="#ff64ad"

                      @change="
                        form.role_kelurahan_code = '';
                        form.role_kelurahan_name = '';"

                      v-model="form.role_kecamatan_code"
                      :success="form.role_kecamatan_code !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Kecamatan {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_kecamatan_code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </div>

                <div v-if="selected.detail.user_role_level === 'Desa / Kelurahan'"
                  class="mt-6 mb-3">
                  <ValidationProvider 
                    name="role_kelurahan_code" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Desa / Kelurahan
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save"
                      style="max-width: 55%;"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. Kradenan"

                      :search-input.sync="autocomplete.village"
                      :loading="process.village"
                      
                      :items="config.village"
                      item-value="desa_code"
                      item-text="desa_name"
                      item-color="#ff64ad"

                      v-model="form.role_kelurahan_code"
                      :success="form.role_kelurahan_code !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Desa / Kelurahan {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.role_kelurahan_code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </div>

                <div
                  class="my-6">
                  <ValidationProvider 
                    name="instansi_phone" 
                    rules="required|min:8|max:13"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Telepon Instansi
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-text-field
                      v-on:keyup.enter="save"
                      style="max-width: 40%;"
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"
                      dense
                      outlined
                      color="#ff64ad"
                      hide-details
                      placeholder="Contoh. 081332XXXXXX"
                      
                      v-model="form.instansi_phone"
                      v-uppercase
                      :success="form.instansi_phone !== '' && valid"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Telepon Instansi {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.instansi_phone !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </div>

                <ValidationProvider 
                  name="instansi_email" 
                  rules="required|email" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Email Instansi
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>
                  
                  <v-text-field
                    v-on:keyup.enter="save"
                    style="max-width: 45%;"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    placeholder="Contoh. XXXXX@gmail.com"

                    v-model="form.instansi_email"
                    :success="form.instansi_email !== '' && valid"
                    :error-messages="errors"
                    required>
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Email Instansi {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.instansi_email !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="Object.keys(selected.detail).length > 0 && form.id === ''"
                class="mt-6 mb-2">
                <v-text-field 
                  dense
                  single-line
                  hide-details
                  color="#ff64ad"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search_user"
                  v-uppercase
                  @click:clear="search_user = ''; fetchUser();"
                  v-on:keyup.enter="fetchUser()">
                </v-text-field>
              </div>

              <v-row v-if="Object.keys(selected.detail).length > 0 && form.id === ''">
                <v-col
                  v-for="(item, index) in process.user ? 8 : list.user"
                  :key="index"
                  cols="3">
                  <v-skeleton-loader
                    class="loader_image"
                    :loading="process.user"
                    type="image">
                    <div>
                      <v-card v-if="!process.user && list.user.length > 0"
                        @click="!form.user_ids.includes(item.id) ? addUser(item.id) : removeUser(item.id)"
                        style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 5px;">
                        <v-img
                          style="border-radius: 5px;"
                          class="d-flex align-end pa-2"
                          width="100%"
                          height="125"
                          alt="vuetify"
                          :src="item.image"
                          gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, .1)">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#ff64ad">
                              </v-progress-circular>
                            </v-row>
                          </template>

                          <!-- <div
                            style="position: absolute; top: 2px; right: 4px;">
                            <v-icon color="white">
                              {{ form.user_ids.includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                            </v-icon>
                          </div> -->

                          <div
                            style="position: absolute; top: 2px; right: 4px;">
                            <v-icon color="white">
                              {{ form.user_ids.includes(item.id) ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline' }}
                            </v-icon>
                          </div>

                          <div
                            class="caption font-weight-bold white--text one-line">
                            {{ item.fullname }}
                          </div>

                          <div
                            class="caption font-weight-bold white--text one-line">
                            {{ item.nik }}
                          </div>
                        </v-img>
                      </v-card>
                    </div>
                  </v-skeleton-loader>
                </v-col>
              </v-row>

              <pagination v-if="Object.keys(selected.detail).length > 0 && pagination.user.total_data > 0 && form.id === ''"
                @changePage="fetchUser($event)" 
                @reloadPage="fetchUser($event)" 
                :model="pagination.user"/>

              <Empty v-if="!process.user && pagination.user.total_data < 1 && form.id === ''"
                margin="mt-4"
                padding="pa-16"
                font="body-2"
                :size="100"
                message="Produk" />
            </v-form>
          </ValidationObserver>

          <v-alert 
            type="error" 
            text dense prominent 
            class="mt-6"
            v-show="message.error.length > 0">
            {{  message.error }}
          </v-alert>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Hapus Data
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data Group Petugas Registrasi yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8" class="d-flex align-center">
                  <!-- ADD -->
                  <div class="mr-3">
                    <v-btn
                      elevation="0"
                      style="background: #00acc133;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                      @click="dialog.form = true; reset();">
                      <v-icon size="18">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah Group
                      </span>
                    </v-btn>
                  </div>

                  <!-- EDIT -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn 
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                      @click="dialog.form = true; reset(selected.row[0]);">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Ubah
                      </span>
                    </v-btn>
                  </div>

                  <!-- DELETE -->
                  <div class="mr-3" v-if="selected.row.length > 0">
                    <v-btn
                      elevation="0"
                      style="background: #f4403433;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                      @click="toDelete()">
                      <v-icon size="18">mdi-delete-circle-outline</v-icon>

                      <span class="ml-1">
                        Hapus
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#ff64ad"
                    placeholder="Cari . . ."
                    v-uppercase
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid text-capitalize"
              :height="`calc(100vh - ${pagination.data.total_data > 0 ? '330px' : '258px'})`"
              :show-select="true"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="headers"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.data.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination.data"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false
        },
        search: '',
        search_user: '',
        selected: {
          row: [],
          delete: [],
          detail: {}
        },
        config: {
          city: [{
            kabupaten_code: '33.10',
            kabupaten_name: 'KLATEN'
          }],
          subdistrict: [],
          village: []
        },
        autocomplete: {
          city: '',
          subdistrict: '',
          village: ''
        },
        options: {},
        headers: [],
        list: {
          role: [],
          user: [],
          data: []
        },
        limit: 20,
        pagination: {
          user: {},
          data: {}
        },
        lastIndex: 0,
        form: {
          id: '',
          role_id: '',
          user_ids: [],
          role_kabupaten_name: '',
          role_kabupaten_code: '',
          role_kecamatan_name: '',
          role_kecamatan_code: '',
          role_kelurahan_name: '',
          role_kelurahan_code: '',

          instansi_phone: '',
          instansi_email: ''
        },
        process: {
          load: false,
          form: false,
          delete: false,
          user: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'form.role_id': function() {
        let t = this
        let rol = this.list.role.filter(function(v) {
          return t.form.role_id == v.id
        })

        if (rol.length > 0) {
          this.selected.detail = rol[0]

          this.fetchUser()

          this.form.role_kabupaten_code = '33.10'
          this.form.role_kabupaten_name = 'KLATEN'
          // this.form.role_kecamatan_code = ''
          // this.form.role_kecamatan_name = ''
          // this.form.role_kelurahan_code = ''
          // this.form.role_kelurahan_name = ''
        }
        
      },
      'form.role_kabupaten_code': function() {
        let t = this
        let kab = this.config.city.filter(function(v) {
          return t.form.role_kabupaten_code == v.kabupaten_code
        })

        if (kab.length > 0) {
          this.form.role_kabupaten_name = kab[0].kabupaten_name

          // this.form.role_kecamatan_code = ''
          // this.form.role_kecamatan_name = ''
          // this.form.role_kelurahan_code = ''
          // this.form.role_kelurahan_name = ''
        }

        this.static().subdistrict()

        this.fetchUser()
      },
      'form.role_kecamatan_code': function() {
        let t = this
        let kec = this.config.subdistrict.filter(function(v) {
          return t.form.role_kecamatan_code == v.kecamatan_code
        })

        if (kec.length > 0) {
          this.form.role_kecamatan_name = kec[0].kecamatan_name

          // this.form.role_kelurahan_code = ''
          // this.form.role_kelurahan_name = ''
        }

        this.static().village()

        this.fetchUser()
      },
      'form.role_kelurahan_code': function() {
        let t = this
        let kel = this.config.village.filter(function(v) {
          return t.form.role_kelurahan_code == v.desa_code
        })

        if (kel.length > 0) {
          this.form.role_kelurahan_name = kel[0].desa_name
        }

        this.fetchUser()
      },
      'autocomplete.subdistrict': function() {
        this.static().subdistrict()
      },
      'autocomplete.village': function() {
        this.static().village()
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('user/list_user_role', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'fullname',
                freeze: false,
                hide: false
              },
              {
                text: 'NIK',
                width: '200px',
                value: 'nik',
                freeze: false,
                hide: false
              },
              {
                text: 'Group Petugas Registrasi',
                width: '200px',
                value: 'user_role_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Level',
                width: '200px',
                value: 'user_role_level',
                freeze: false,
                hide: false
              },
              {
                text: 'Hak Akses',
                width: '400px',
                value: 'user_role_access',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination.data = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
          }
        })
      },
      async fetchRole (item) {
        this.list.role = []

        await get('user_role')
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            res.data.map(obj => {
              this.list.role.push({
                id: obj.id,
                user_role_id: obj.user_role_id,
                user_role_name: `${obj.user_role_name} - ${obj.user_role_level}`,
                user_role_access: obj.user_role_access,
                user_role_level: obj.user_role_level
              })
            })

            if (item !== undefined) {
              this.fetchUser()

              this.list.role.map(obj => {
                if (obj.id === this.form.role_id) {
                  this.selected.detail = obj
                }
              })
            }
          }
        })
      },
      async fetchUser (pagination = { row: 20, page: 1 }) {
        this.process.user = true

        let params = {
          limit: pagination.row,
          page: pagination.page,
          role_id: 0,
          search: this.search_user,
          // kecamatan_name: this.form.role_kecamatan_name,
          // kelurahan_name: this.form.role_kelurahan_name
        }

        await get('user', { params })
        .then(response => {
          let res = response.data
            
          if (res.code === 200) {
            this.process.user = false

            this.list.user = res.data
            this.pagination.user = res.pagination
          }
        })
      },
      static () {
        let t = this
        return {
          async subdistrict () {
            t.process.subdistrict = true

            let params = {
              search: t.autocomplete.subdistrict,
              sort: 'DESC'
            }

            await get('location/kecamatan', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.subdistrict = false

                t.config.subdistrict = res.data
              }
            })
          },
          async village () {
            t.process.village = true

            let params = {
              desa_kecamatan_code: t.form.role_kecamatan_code,
              search: t.autocomplete.village,
              sort: 'DESC'
            }

            await get('location/desa', { params })
            .then(response => {
              let res = response.data
            
              if (res.code === 200) {
                t.process.village = false

                t.config.village = res.data
              }
            })
          }
        }
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          role_id: item !== undefined ? item.role_id : '',
          user_ids: item !== undefined ? [item.id] : [],
          role_kabupaten_name: item !== undefined ? item.role_kabupaten_name : '',
          role_kabupaten_code: item !== undefined ? item.role_kabupaten_code : '',
          role_kecamatan_name: item !== undefined ? item.role_kecamatan_name : '',
          role_kecamatan_code: item !== undefined ? item.role_kecamatan_code : '',
          role_kelurahan_name: item !== undefined ? item.role_kelurahan_name : '',
          role_kelurahan_code: item !== undefined ? item.role_kelurahan_code : '',
          
          instansi_phone: item !== undefined ? item.extra.instansi_phone : '',
          instansi_email: item !== undefined ? item.extra.instansi_email : ''
        }

        this.selected.detail = {}

        this.list.user = []
        this.pagination.user = {}
        
        this.process.form = false

        this.message.error = ''

        this.fetchRole(item)
      },
      addUser (id) {
        this.form.user_ids = []

        this.form.user_ids.push(id)
      },
      removeUser (id) {
        let myIndex = this.form.user_ids.indexOf(id)

        if (myIndex !== -1) {
          this.form.user_ids.splice(myIndex, 1)
        }
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('user/add_user_to_group', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true

              this.message.success = res.message

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('user/delete_user_from_group', {
          data: {
            user_ids: this.selected.delete
          }
        }).then(response => {
          let res = response.data

          if (res.code === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .loader_image .v-skeleton-loader__image {
    height: 125px !important;
  }
</style>